import React from 'react'
import styled from 'styled-components'
import { isNil } from 'ramda'
import { Container } from 'reactstrap'
import CredentialList from './CredentialList'
import {
  getElementsArr,
  hasCredentials,
  hasOnlyOneSection
} from './shared'

export const FlexContainer = styled(Container)`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  > div:nth-child(n + 3) {
    width: 100%;
    margin: 30px 0;
    border-top: 1px solid ${props => props.theme.colors.greyBlue};
  }
  > div:only-child {
    justify-content: center;
    flex-basis: 100%;
  }
  @media screen and (max-width: 992px) {
    flex-direction: row;
    > div:nth-child(n + 2) {
      border-top: 1px solid ${props => props.theme.colors.greyBlue};
      margin: 30px 0;
    }
  }
`

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  background-color: white;
  max-width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  padding-bottom: 40px;
  flex-wrap: wrap;
`

const ElementWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-basis: 45%;
  @media screen and (max-width: 992px) {
    flex-basis: 100%;
  }
`

export default({ data }) => {
  const elements = getElementsArr(data)
  return hasCredentials(data)
    ? (
      <Wrapper>
        <FlexContainer>
          {
            Object.keys(elements)
              .filter(el => !isNil(elements[el]))
              .map((item, i) => (elements[item].length)
                ? (
                  <ElementWrapper key={item}>
                    <CredentialList name={item} data={elements[item]} count={hasOnlyOneSection(elements)} />
                  </ElementWrapper>
                )
                : null
              )
          }
        </FlexContainer>
      </Wrapper>
    )
    : null
}
